import {colorPalette, fontWeight, fontSize} from '../../../config';
import {
	cardTitleProps,
	ulsContentProps,
	ulsTitleProps,
	subTitleProps,
	thProps,
	tdProps,
} from '../../common';
import {giftImg, giftImg2, giftImg3} from '../../../config/images';
export const provideTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl3,
			tablet: '36px',
			mobile: '26px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
		fontFamily: 'Gmarket',
	},
	description: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: '16px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
	},
};
export const imageProps = {
	src: giftImg,
	alt: '기념품',
};
export const imageProps2 = {
	src: giftImg2,
	alt: '기념품',
};
export const imageProps3 = {
	src: giftImg3,
	alt: '기념품',
};

// export const imageDescription = {
// 	items: [
// 		{
// 			content: {
// 				...ulsContentProps,
// 				children: '색상은 랜덤으로 제공됩니다.',
// 			},
// 		},
// 		{
// 			content: {
// 				...ulsContentProps,
// 				children:
// 					'기념품은 사전 발송 없이 현장 참석자들에게만 완주 후 지급합니다.(추후 발송도 없음)',
// 			},
// 		},
// 	],
// };

export const provide = {
	uls: [
		// {
		// 	listStyle: 'circle',
		// 	items: [
		// 		{
		// 			content: {
		// 				...ulsContentProps,
		// 				children: '기념품, 배번호, 안내책자',
		// 			},
		// 		},
		// 	],
		// },
		{
			listStyle: 'circle',
			items: [
				// {
				// 	title: {...ulsTitleProps, children: '10.19km'},
				// 	content: {
				// 		...ulsContentProps,
				// 		children:
				// 			'10.19km : 기념품(야광밴드, 순천사랑 상품권 1만원권), 메달, 짐보관백, 보험, 배번호, 기록칩, 웹기록증, 테이핑서비스',
				// 	},
				// },
				{
					title: {...ulsTitleProps, children: '5km'},
					content: {
						...ulsContentProps,
						children:
							'고온으로 인한 변질 우려 등으로 간식은 제공하지 않습니다. \n주로 1.5km 간격, 도착지점에 급수대 운영합니다. (지급품: 물+이온음료)',
					},
				},
			],
		},
		// {
		// 	listStyle: 'circle',
		// 	items: [
		// 		{
		// 			content: {
		// 				...ulsContentProps,
		// 				children:
		// 					'번호표 분실 또는 미지참 시 대회장에서 재발급이 불가능합니다.',
		// 				color: colorPalette.warn,
		// 				fontWeight: fontWeight.bold,
		// 			},
		// 		},
		// 	],
		// },
	],
};
export const provideTitle = {
	title: {
		text: {...cardTitleProps, children: '10.19km'},
	},
	description: {
		...provideTextProps.description,
		children: '여수산 멸치 600g 내외, 여순사건 추모 동백키링',
	},
};

export const provideTitle2 = {
	title: {
		text: {...cardTitleProps, children: '5km'},
	},
	description: {
		...provideTextProps.description,
		children: '여순사건 추모 손수건 2장, 여순사건 추모 동백키링 1개',
	},
};
export const provideTitle3 = {
	title: {
		text: {...cardTitleProps, children: '완주메달'},
	},
	description: {
		...provideTextProps.description,
		children: '완주 기념품',
	},
};
